import ScheduleMaintenance from "../views/maintenance/schedulemaintenance";

const TitlesHeading = {
  customerListGpwisRfq: "Customer RFQs - GPWIS",
  customerlistsftorfq: "Customer RFQs - SFTO",
  vendorlistrfq: "Vendor RFQs",
  customerSftoListQuotation: "Customer Quotations - SFTO",
  customerGpwisListQuotation: "Customer Quotations - GPWIS",
  vendorlistquotation: "Vendor Quotations",
  customerlistcontract: "Customer Contract",
  customerSftoListContract: "Customer Contracts - SFTO",
  customerGpwisListContract: "Customer Contracts - GPWIS",
  vendorlistcontract: "Vendor Contract",
  customerlistjob: "Customer Job",
  customerSftoListJob: "Customer Jobs - SFTO",
  customerGpwisListJob: "Customer Jobs - GPWIS",
  vendorlistjob: "Vendor Job",
  customerListRake: "Rake",
  wagondamagelist: "Wagon Damage List",
  rakeInductionList: "Rake Induction List",
  dsrlist: "Daily Status Report List",
  rakeMaintenanceList: "Rake Maintenance",
  rakeMasterList: "Rake Master",
  wagonmasterlist: "Wagon Master",
  contractHeadermasterlist: "Contract Master",
  vendorMasterlist: "Vendor Contract Master",
  contractMasterUploadData: "Upload Contract Master",
  CommodityMasterList: "Commodity Master",
  ShipToPartyMasterList: "Ship To Party Master",
  dailyPositionReport: "Monthly Targets",
  thresholdmasterlist: "Cusotmer Threshold Master",
  MaterialClassMaster: "Material Class Master",
  FrieghtMaster: "Frieght Master",
  ExaminationTypeMaster: "Examination Type Master",
  DepoMaster: "Depot Master",
  WagonComponentMaster: "Wagon Component Master",
  RohPohScheduleMaster: "ROH POH Schedule Master",
  RakeRebateMaster: "Rake Rebate Master",
  ODpairMaster: "Create OD Pair Master",
  TATReconciliationMaster: "Create TAT Reconciliation Master",
  stationMaster: "Station Master",
  CurrentComposition: "Current Composition",
  ScheduleMaintenance: "Schedule Maintenance",
  SpareScheduleMaintenance: "Spare Schedule Maintenance",
  WagonMasterUploadData: "Upload Wagon Master",
};
const PathsHeading = {
  customerlistrfq: "Create RFQ",
  customerSftoListRfq: "Create RFQ - SFTO",
  customerGpwisListRfq: "Create RFQ - GPWIS",
  vendorlistrfq: "RFQ",
  customerListGpwisQuotation: "Create Quotation - GPWIS",
  customerListSftoQuotation: "Create Quotation - SFTO",
  customerlistquotation: "Create Quotation",
  vendorlistquotation: "Create Quotation",
  customerListGpwisContract: "Create Contract - GPWIS",
  customerListSftoContract: "Create Contract - SFTO",
  customerlistcontract: "Create Contract",
  vendorlistcontract: "Create Contract",
  customerlistjob: "Create Job",
  customerSftoListJob: "Create Job",
  customerListGpwisJob: "Save Leg / Job - GPWIS",
  gpwisjobapprove: "Approve Leg / Job - GPWIS",
  sftojobapprove: "Approve Job - SFTO",
  customerListSftoJob: "Create Job - SFTO",
  editSftoJob: "Edit Job - SFTO",
  customerApproveSftoJob: "Approve Job - SFTO",
  vendorlistjob: "Create Job",
  customerlistrake: "New Rake",
  vendorlistjob: "New Rake",
  wagondamagelist: "Report Wagon Damage",
  rakeInductionList: "Add Rake",
  revenueandpurchasedetails: "Revenue & Purchase Details",
  createDamageWagonDetails: "Record Wagon Damage",
  createWagonMaster: "Create Wagon",
  rakeMaintenanceList: "Create Rake Maintenance",
  rakeMasterList: "Create Rake Master",
  wagonmasterlist: "Create Wagon Master",
  cargomaster: "Create Commodity Master",
  ShipToPartyMaster: "Create Ship To Party Master",
  contractHeadermasterlist: "Create Contract Master",
  vendorMasterlist: "Create Vendor Contract Master",
  routeMasterList: "Create Route Master",
  transactionDefaults: "SAP Defaults",
  contractadvance: "Contract Advance",
  contractMasterUploadData: "Upload Contract Master",
  consolidatedInvoice: "Consolidated Invoice",
  thresholdmasterlist: "Create Cusotmer Threshold Value",
  MaterialClassMaster: "Create Material Class",
  FrieghtMaster: "Create Frieght Master",
  ExaminationTypeMaster: "Create Examination Type Master",
  DepoMaster: "Create Depot Master",
  WagonComponentMaster: "Create Wagon Component Master",
  RohPohScheduleMaster: "Create ROH POH Schedule Master",
  RakeRebateMaster: "Rake Rebate Master",
  ODpairMaster: "Create OD Pair Master",
  TATReconciliationMaster: "Create TAT Reconciliation Master",
  RebateInvoice: "Create Rebate Invoice Report",
  stationMaster: "Create New Station",
  CurrentComposition: "Create Current Composition",
  ScheduleMaintenance: "Create Schedule Maintenance",
  SpareScheduleMaintenance: "Create Spare Schedule Maintenance",
  WagonMasterUploadData: "Upload Wagon Master",
};
const TitlesNavigation = {
  customerlistrfq: "RFQ / SFTO",
  customerListGpwisRfq: "RFQ / GPWIS",
  vendorlistrfq: "Railways/RFQ/rfq",
  customerlistquotation: "quotation",
  vendorlistquotation: "Railways/Quotation/vendorquotation",
  customerlistcontract: "viewcontract",
  vendorlistcontract: "Railways/Quotation/vendorcontract",
  sftocreatejob: "Create Job",
  sftoeditjob: "Edit Job",
  sftoapprovejob: "Approve Job",
  customerlistjob: " Jobs - GPWIS",
  gpwisjobapprove: " Jobs - GPWIS",
  sftojobapprove: "Job",
  customerSftoListJob: " Jobs - SFTO",
  vendorlistjob: "viewjob",
  customerlistrake: "rake",
  vendorlistrake: "rake",
  wagondamagelist: "Wagon damage",
  rakeInductionList: "Rake Induction",
  reportwagondamage: "Report for wagon damage",
  revenueandpurchasedetails: "Revenue & Purchase Details",
  dsrlist: "Daily Status Report",
  rakeMaintenanceList: "Rake Maintenance",
  rakeMasterList: "Rake Master",
  wagonmasterlist: "Wagon Master",
  cargomaster: "Commodity Master",
  ShipToPartyMaster: "Ship To Party Master",
  contractHeadermasterlist: "Contract Master",
  vendorMasterlist: "Vendor Contract Master",
  contractMasterUploadData: "Upload Contract Master",
  routeMasterList: "Route Master",
  transactionDefaults: "SAP Defaults",
  contractadvance: "Contract Advance",
  dailyPositionReport: "Create",
  thresholdmasterlist: "Customer Threshold Master",
  MaterialClassMaster: "Material Class Master",
  FrieghtMaster: "Frieght Master",
  ExaminationTypeMaster: "Examination Type Master",
  DepoMaster: "Depot Master",
  WagonComponentMaster: "Wagon Component Master",
  RohPohScheduleMaster: "ROH POH Schedule Master",
  RakeRebateMaster: "Rake Rebate Master",
  ODpairMaster: "OD Pair Master",
  TATReconciliationMaster: "TAT Reconciliation Master",
  RebateInvoice: "Rebate Invoice Report",
  stationMaster: "Station Master",
  CurrentComposition: "Current Composition",
  ScheduleMaintenance: "Schedule Maintenance",
  SpareScheduleMaintenance: "Spare Schedule Maintenance",
  WagonMasterUploadData: "Upload Wagon Master",
};
const PathsNavigation = {
  customerlistsftorfq: "sftorfq",
  customerListGpwisRfq: "gpwisrfq",
  vendorlistrfq: "rfq",
  customerListSftoQuotation: "sftoquotation",
  customerListGpwisQuotation: "gpwisquotation",
  vendorlistquotation: "createvendorquotation",
  customerListSftoContract: "sftocontract",
  customerListGpwisContract: "gpwiscontract",
  customerlistcontract: "contract",
  vendorlistcontract: "createvendorcontract",
  customerSftoListJob: "createjob",
  customerlistjob: "Job",
  customerListSftoJob: "sftojob",
  customerApproveSftoJob: "sftojob",
  customerListGpwisJob: "createjob",
  vendorlistjob: "viewjob",
  customerlistrake: "rake",
  vendorlistrake: "rake",
  wagondamagelist: "report",
  rakeInductionList: "addrake",
  revenueandpurchasedetails: "Revenue & Purchase Details",
  rakeMaintenanceList: "create",
  rakeMasterList: "createrake",
  wagonmasterlist: "createwagon",
  cargomaster: "createCommodity",
  routeMasterList: "createroute",
  transactionDefaults: "sap defaults data",
  contractadvance: "Contract Advance",
  contractHeadermasterlist: "createContract",
  vendorMasterlist: "createVendor",
  contractMasterUploadData: "Upload Contract Master",
  dailyPositionReport: "create",
  shipToPartyMaster: "createShipToParty",
  thresholdmasterlist: "createthreshold",
  MaterialClassMaster: "createClass",
  FrieghtMaster: "createfrieghtmaster",
  ExaminationTypeMaster: "createexaminationtypemaster",
  DepoMaster: "createdepomaster",
  WagonComponentMaster: "createwagoncomponentmaster",
  RohPohScheduleMaster: "createrohschedulemaster",
  RakeRebateMaster: "createrake",
  ODpairMaster: "createodpairmaster",
  TATReconciliationMaster: "createtatreconciliationmaster",
  stationMaster: "createStation",
  CurrentComposition: "createcurrentcomposition",
  ScheduleMaintenance: "createschedulemaintenance",
  SpareScheduleMaintenance: "createspareschedulemaintenance",
  WagonMasterUploadData: "Upload Wagon Master",
  ExaminationTypeMaster: "createexaminationtypemaster",
  DepoMaster: "createdepomaster",
  WagonComponentMaster: "createwagoncomponentmaster",
  RohPohScheduleMaster: "createrohschedulemaster",
};
export default {
  TitlesHeading,
  TitlesNavigation,
  PathsHeading,
  PathsNavigation,
};
